import { Component, OnInit, Injector, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { EngineerScheduleEditService } from './engineer-schedule-edit.service';
import { CreateFormGroupArgs } from '@progress/kendo-angular-grid';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../auth.service';

@Component({
  selector: 'app-engineer-schedule',
  templateUrl: './engineer-schedule.component.html',
  styleUrls: ['./engineer-schedule.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EngineerScheduleComponent implements OnInit {
  private readonly engineerScheduleEditService: EngineerScheduleEditService;
  public readonly authService: AuthenticationService;
  private readonly _fullScreenToggled: any;
  public fullScreenToggled = false;
  public schedulerHeight = '459';
  public selectedDate: Date = new Date();
  public formGroup: UntypedFormGroup;


  constructor(
    public router: Router,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly appService: AppService,
    private readonly injector: Injector
    ) {
    this.engineerScheduleEditService = injector.get(EngineerScheduleEditService);
    this.authService = injector.get(AuthenticationService);

    this._fullScreenToggled = appService.fullScreenToggled.subscribe((isFullScreen) => {
      isFullScreen ? this.schedulerHeight = '573' : this.schedulerHeight = '459';
      this.fullScreenToggled = isFullScreen;
    });
    this.createFormGroup = this.createFormGroup.bind(this);
  }

  public createFormGroup(args: CreateFormGroupArgs): UntypedFormGroup {
    const dataItem = args.dataItem;

    this.formGroup = this.formBuilder.group({
        'Id': dataItem.Id ? dataItem.Id : '',
        'PlannedStartDate': dataItem.PlannedStartDate,
        'PlannedCompletionDate': dataItem.PlannedCompletionDate,
        'Description': [dataItem.Description, Validators.required],
        'Engineer': dataItem.Engineer,
    });
    return this.formGroup;
}

  /**
   * Calls the read for scheduler editing service after user information has been captured.
   *
   * @memberof EngineerScheduleComponent
   */
  ngOnInit() {
    this.authService.getUserProfile().subscribe(user => {
      this.engineerScheduleEditService.loading = true;
      if (user.GMIN) {
        this.engineerScheduleEditService.userProfile = user;
        this.engineerScheduleEditService.read();
      }
    });
  }

  back = () => this.router.navigate(['/VE']);

  /**
  * Prevents editing on workorders and holidays.
  *
  * @param {*} event
  * @memberof WorkOrderScheduleComponent
  */
  editHandler(event: any) {
    if (event.dataItem.isHoliday || event.dataItem.isWorkOrder) {
      event.preventDefault();
    }
  }

  navigateHandler(event: any) {
    console.log('Test');
  }

  getEventClass(event) {
    return event.dataItem.isHoliday ? 'holidayClass' : event.dataItem.isWorkOrder ? 'workOrderClass' : 'eventClass';
  }
}
